module.exports = __webpack_public_path__ + "img/user-icon.bc0af550.svg";